// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".referral-toggle-link {\n  border: 0;\n  background: transparent;\n  color: #6d28d9;\n  cursor: pointer;\n  font-size: 14px;\n  padding: 0;\n  text-decoration: none;\n}\n.referral-toggle-link:hover {\n  text-decoration: underline;\n}\n", ""]);
// Exports
module.exports = exports;
